import type { Assistant } from "@inrev/assistant";
import { AssistantContextType, type Relations } from "@inrev/common";
import { match } from "ts-pattern";

export const toAssistantContext = (
	relation: Relations.Notes,
): Assistant.Dtos.Conversation.Create.Request =>
	match(relation)
		.with({ relationType: "account" }, ({ relationId }) => ({
			contextType: AssistantContextType.account,
			contextId: relationId,
		}))
		.with({ relationType: "quote" }, ({ relationId }) => ({
			contextType: AssistantContextType.bond_request,
			contextId: relationId,
		}))
		.with({ relationType: "bond" }, ({ relationId }) => ({
			contextType: AssistantContextType.bond,
			contextId: relationId,
		}))
		.exhaustive();
